import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import Accordion from '@mui/material/Accordion';

export const StyGrid = styled(Box, {
    name: 'StyGrid',
    shouldForwardProp: (prop) => prop !== 'highlightedMetric',
})<{ highlightedMetric: string }>(({ highlightedMetric, theme }) => {
    return {
        '&& .ag-root-wrapper': {
            borderBottomLeftRadius: '4px',
            borderBottomRightRadius: '4px',
        },
        marginLeft: '1rem',
        [`& .ag-header-cell[col-id="${highlightedMetric}"] .ag-header-cell-text`]:
            {
                color: theme.palette.primary.main,
                fontWeight: 'bold',
            },
        [`& .ag-cell[col-id="${highlightedMetric}"]`]: {
            color: theme.palette.primary.main,
            fontWeight: 'bold',
        },
    };
});

export const StyAccordion = styled(Accordion, {
    name: 'StyAccordion',
})(({ theme }) => ({
    width: '100%',
    borderRadius: '4px',
    '&& .Mui-expanded': {
        minHeight: '0px',
        margin: '0',
    },
    '& .MuiIconButton-edgeEnd': {
        marginRight: 0,
    },
    '& .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
    },
    '&::before': {
        height: '0px',
    },
    marginTop: '1rem',
}));
